module.exports = __webpack_public_path__ + "static/media/banner-close-icon.022ea40c.svg";